import { Stream } from "@domain";

export interface PremeetingState {
  premeetingStream: Stream | null;
}

export const defaultPremeetingState: PremeetingState = {
  premeetingStream: null
};
